import log from '@atlassian/jira-common-util-logging/src/log.tsx';
import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import type { SubProduct } from './types.tsx';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (subProduct: SubProduct) => {
	performGetRequest(`/rest/internal/2/mauTag/${subProduct}`).catch((err) => {
		log.safeErrorWithoutCustomerData(
			'common.tag-mau.tag-mau-event',
			'Error connecting to monolith mau tag endpoint',
			err,
		);
	});
};
